import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=13eb1a97"
import script from "./Messages.ts?vue&type=script&lang=ts&external"
export * from "./Messages.ts?vue&type=script&lang=ts&external"
import style0 from "./Messages.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports